export const FLIGHT_TYPE_NAMES = {
  national: "Nacional",
  european: "Europeo",
  international: "Internacional",
};
